// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FeatureSection.css */

.feature-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  padding: 2rem;
  background-color: #fefefa;
  text-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.8rem;
  margin-bottom: 0.8rem;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .feature-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}
/* sectiune layout */
.series-section {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.series-header h2 {
  font-size: 2rem;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 30px;
  color: #333;
}

.series-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.category {
  flex: 1 1;
  min-width: 250px;
  background-color: #f8f8f8;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.category:hover {
  background-color: #eee;
}

.image-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.category:hover img {
  transform: scale(1.05);
}

.category h3 {
  font-size: 1.2rem;
  font-weight: 400;
  color: #555;
  margin: 20px;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .series-header h2 {
    font-size: 1.5rem;
    text-align: center;
  }
  
  .series-categories {
    flex-direction: column;
  }
  
  .category {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .series-section {
    padding: 20px 10px;
  }
  
  .series-header h2 {
    font-size: 1.3rem;
  }
  
  .category h3 {
    font-size: 1rem;
    margin: 15px;
  }
  
  .image-container {
    height: 150px;
  }
}
.furniture-hero1 {
  background: linear-gradient(135deg, #f8f6f3 0%, #ebe6e0 100%);
  padding: 2rem 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.hero-container1 {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.hero-content1 {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.hero-text1 {
  max-width: 500px;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 300;
  color: #2c2c2c;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.hero-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-weight: 400;
}

.hero-details {
  font-size: 0.95rem;
  color: #777;
  line-height: 1.6;
  font-weight: 400;
}

.features-grid {
  display: grid;
  gap: 2rem;
  max-width: 450px;
}

.feature-card {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.feature-icon {
  width: 32px;
  height: 32px;
  color: #8b6f47;
  margin-bottom: 0.5rem;
}

.feature-icon svg {
  width: 100%;
  height: 100%;
}

.feature-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c2c2c;
  margin: 0;
  line-height: 1.3;
}

.feature-description {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.hero-image {
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.kitchen-showcase {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
}

.kitchen-interior {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #f5f2ed 0%, #e8e2d8 50%, #d4c8b8 100%);
}

.kitchen-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(139, 111, 71, 0.1) 0%,
    rgba(200, 180, 150, 0.15) 50%,
    rgba(100, 80, 60, 0.1) 100%
  );
}

.kitchen-elements {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.cabinet-upper {
  position: absolute;
  top: 80px;
  right: 60px;
  width: 200px;
  height: 80px;
  background: linear-gradient(135deg, #8b6f47 0%, #a0845a 100%);
  border-radius: 4px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cabinet-upper::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
}

.cabinet-lower {
  position: absolute;
  bottom: 120px;
  right: 60px;
  width: 200px;
  height: 120px;
  background: linear-gradient(135deg, #6b5637 0%, #8b6f47 100%);
  border-radius: 4px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.island {
  position: absolute;
  bottom: 160px;
  left: 50%;
  transform: translateX(-30%);
  width: 180px;
  height: 60px;
  background: linear-gradient(135deg, #f0ede8 0%, #d4c8b8 100%);
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.island::after {
  content: '';
  position: absolute;
  top: -15px;
  left: 10px;
  right: 10px;
  height: 8px;
  background: linear-gradient(135deg, #c8b89d 0%, #b5a48e 100%);
  border-radius: 4px;
}

.dining-area {
  position: absolute;
  bottom: 60px;
  left: 60px;
  width: 250px;
  height: 200px;
}

.table {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 80px;
  background: linear-gradient(135deg, #4a3f35 0%, #5c4f42 100%);
  border-radius: 6px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.table::before {
  content: '';
  position: absolute;
  top: -6px;
  left: -10px;
  right: -10px;
  height: 12px;
  background: linear-gradient(135deg, #6b5a4a 0%, #7d6b5a 100%);
  border-radius: 8px;
}

.chairs {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 140px;
}

.chair {
  position: absolute;
  width: 35px;
  height: 60px;
  background: linear-gradient(135deg, #3a3330 0%, #4a3f3c 100%);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.chair:nth-child(1) {
  bottom: 80px;
  left: 40px;
  transform: rotate(-15deg);
}

.chair:nth-child(2) {
  bottom: 75px;
  left: 100px;
  transform: rotate(10deg);
}

.chair:nth-child(3) {
  bottom: 80px;
  right: 100px;
  transform: rotate(-8deg);
}

.chair:nth-child(4) {
  bottom: 85px;
  right: 40px;
  transform: rotate(12deg);
}

.chair::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 2px;
  right: 2px;
  height: 25px;
  background: linear-gradient(135deg, #4a3f3c 0%, #5a4d47 100%);
  border-radius: 4px 4px 2px 2px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .hero-container1 {
    gap: 3rem;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
}

@media (max-width: 968px) {
  .hero-container1 {
    grid-template-columns: 1fr;
    gap: 3rem;
    text-align: center;
  }
  
  .hero-content1 {
    order: 1;
  }
  
  .hero-image {
    order: 0;
    height: 400px;
  }
  
  .hero-text1 {
    max-width: 100%;
  }
  
  .features-grid {
    max-width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 2rem;
  }
}

@media (max-width: 768px) {
  .furniture-hero1 {
    padding: 1rem 0;
  }
  
  .hero-container1 {
    padding: 0 1rem;
    gap: 2rem;
  }
  
  .hero-title {
    font-size: 1.8rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .hero-image {
    height: 350px;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.6rem;
    line-height: 1.3;
  }
  
  .hero-description,
  .hero-details {
    font-size: 0.9rem;
  }
  
  .feature-title {
    font-size: 1.3rem;
  }
  
  .feature-description {
    font-size: 0.9rem;
  }
  
  .hero-image {
    height: auto;
  }

}

.hero-image img {
  width: 100%;
  max-width: 450px; /* păstrează limita maximă pe desktop */
  height: auto; /* păstrează proporțiile */
  display: block;
}

@media (max-width: 768px) {
  .hero-image img {
    display: flex;
    margin: auto;
    justify-content: center;
    max-width: 100%; /* pe mobil, imaginea ocupă tot spațiul containerului */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Acasa.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;AACA,oBAAoB;AACpB;EACE,gDAAgD;EAChD,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;AAEF;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,uCAAuC;EACzD,YAAY,EAAE,0BAA0B;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,eAAe,EAAE,uDAAuD;EAC1E;AACF","sourcesContent":["/* FeatureSection.css */\n\n.feature-section {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2rem;\n  padding: 2rem;\n  background-color: #fefefa;\n  text-align: center;\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n}\n\n.feature {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  font-size: 1.8rem;\n  margin-bottom: 0.8rem;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .feature-section {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n}\n/* sectiune layout */\n.series-section {\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.series-header h2 {\n  font-size: 2rem;\n  font-weight: 300;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.series-categories {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.category {\n  flex: 1;\n  min-width: 250px;\n  background-color: #f8f8f8;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.category:hover {\n  background-color: #eee;\n}\n\n.image-container {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.image-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.category:hover img {\n  transform: scale(1.05);\n}\n\n.category h3 {\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: #555;\n  margin: 20px;\n  text-align: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .series-header h2 {\n    font-size: 1.5rem;\n    text-align: center;\n  }\n  \n  .series-categories {\n    flex-direction: column;\n  }\n  \n  .category {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .series-section {\n    padding: 20px 10px;\n  }\n  \n  .series-header h2 {\n    font-size: 1.3rem;\n  }\n  \n  .category h3 {\n    font-size: 1rem;\n    margin: 15px;\n  }\n  \n  .image-container {\n    height: 150px;\n  }\n}\n.furniture-hero1 {\n  background: linear-gradient(135deg, #f8f6f3 0%, #ebe6e0 100%);\n  padding: 2rem 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.hero-container1 {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n.hero-content1 {\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n\n.hero-text1 {\n  max-width: 500px;\n}\n\n.hero-title {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: #2c2c2c;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n  font-weight: 400;\n}\n\n.hero-details {\n  font-size: 0.95rem;\n  color: #777;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n.features-grid {\n  display: grid;\n  gap: 2rem;\n  max-width: 450px;\n}\n\n.feature-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.feature-icon {\n  width: 32px;\n  height: 32px;\n  color: #8b6f47;\n  margin-bottom: 0.5rem;\n}\n\n.feature-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.feature-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #2c2c2c;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.feature-description {\n  font-size: 0.95rem;\n  color: #666;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.hero-image {\n  height: 600px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.kitchen-showcase {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.kitchen-interior {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: linear-gradient(135deg, #f5f2ed 0%, #e8e2d8 50%, #d4c8b8 100%);\n}\n\n.kitchen-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    45deg,\n    rgba(139, 111, 71, 0.1) 0%,\n    rgba(200, 180, 150, 0.15) 50%,\n    rgba(100, 80, 60, 0.1) 100%\n  );\n}\n\n.kitchen-elements {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.cabinet-upper {\n  position: absolute;\n  top: 80px;\n  right: 60px;\n  width: 200px;\n  height: 80px;\n  background: linear-gradient(135deg, #8b6f47 0%, #a0845a 100%);\n  border-radius: 4px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.cabinet-upper::before {\n  content: '';\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  right: 20px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.cabinet-lower {\n  position: absolute;\n  bottom: 120px;\n  right: 60px;\n  width: 200px;\n  height: 120px;\n  background: linear-gradient(135deg, #6b5637 0%, #8b6f47 100%);\n  border-radius: 4px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n\n.island {\n  position: absolute;\n  bottom: 160px;\n  left: 50%;\n  transform: translateX(-30%);\n  width: 180px;\n  height: 60px;\n  background: linear-gradient(135deg, #f0ede8 0%, #d4c8b8 100%);\n  border-radius: 8px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.island::after {\n  content: '';\n  position: absolute;\n  top: -15px;\n  left: 10px;\n  right: 10px;\n  height: 8px;\n  background: linear-gradient(135deg, #c8b89d 0%, #b5a48e 100%);\n  border-radius: 4px;\n}\n\n.dining-area {\n  position: absolute;\n  bottom: 60px;\n  left: 60px;\n  width: 250px;\n  height: 200px;\n}\n\n.table {\n  position: absolute;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 120px;\n  height: 80px;\n  background: linear-gradient(135deg, #4a3f35 0%, #5c4f42 100%);\n  border-radius: 6px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.table::before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: -10px;\n  right: -10px;\n  height: 12px;\n  background: linear-gradient(135deg, #6b5a4a 0%, #7d6b5a 100%);\n  border-radius: 8px;\n}\n\n.chairs {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 140px;\n}\n\n.chair {\n  position: absolute;\n  width: 35px;\n  height: 60px;\n  background: linear-gradient(135deg, #3a3330 0%, #4a3f3c 100%);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.chair:nth-child(1) {\n  bottom: 80px;\n  left: 40px;\n  transform: rotate(-15deg);\n}\n\n.chair:nth-child(2) {\n  bottom: 75px;\n  left: 100px;\n  transform: rotate(10deg);\n}\n\n.chair:nth-child(3) {\n  bottom: 80px;\n  right: 100px;\n  transform: rotate(-8deg);\n}\n\n.chair:nth-child(4) {\n  bottom: 85px;\n  right: 40px;\n  transform: rotate(12deg);\n}\n\n.chair::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: 2px;\n  right: 2px;\n  height: 25px;\n  background: linear-gradient(135deg, #4a3f3c 0%, #5a4d47 100%);\n  border-radius: 4px 4px 2px 2px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .hero-container1 {\n    gap: 3rem;\n  }\n  \n  .hero-title {\n    font-size: 2.2rem;\n  }\n}\n\n@media (max-width: 968px) {\n  .hero-container1 {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n    text-align: center;\n  }\n  \n  .hero-content1 {\n    order: 1;\n  }\n  \n  .hero-image {\n    order: 0;\n    height: 400px;\n  }\n  \n  .hero-text1 {\n    max-width: 100%;\n  }\n  \n  .features-grid {\n    max-width: 100%;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n    margin-top: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .furniture-hero1 {\n    padding: 1rem 0;\n  }\n  \n  .hero-container1 {\n    padding: 0 1rem;\n    gap: 2rem;\n  }\n  \n  .hero-title {\n    font-size: 1.8rem;\n  }\n  \n  .hero-description {\n    font-size: 1rem;\n  }\n  \n  .hero-image {\n    height: 350px;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 1.6rem;\n    line-height: 1.3;\n  }\n  \n  .hero-description,\n  .hero-details {\n    font-size: 0.9rem;\n  }\n  \n  .feature-title {\n    font-size: 1.3rem;\n  }\n  \n  .feature-description {\n    font-size: 0.9rem;\n  }\n  \n  .hero-image {\n    height: auto;\n  }\n\n}\n\n.hero-image img {\n  width: 100%;\n  max-width: 450px; /* păstrează limita maximă pe desktop */\n  height: auto; /* păstrează proporțiile */\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .hero-image img {\n    display: flex;\n    margin: auto;\n    justify-content: center;\n    max-width: 100%; /* pe mobil, imaginea ocupă tot spațiul containerului */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
